<template>
  <section id="account" class="pt-5">
	<div class="flex flex-col justify-center align-center px-10">
	  <div class="flex flex-col text-left w-full mt-0 mb-5">
		<h1 class="big-title mb-0 flex p-ai-center">
			<span class="font-normal mr-2">Bonjour,</span>
			<skeleton-loader-vue v-if="!currentUsername"
				type="rect"
				:width="200"
				:height="50"
				animation="wave"
				rounded
			/>
			<span v-else>
				{{ currentUsername }} !
			</span>
		</h1>
		<p class="subtitle">Retrouvez ici vos informations de compte</p>
	  </div>

	  <!-- ANCHOR Informations personnelles -->
	  <form id="user-info" method="post" class="flex" @submit.prevent="updateInformations">
		<div class="flex flex-col w-2/5 my-5 input-col mr-5">
		  <h2>Vos informations personnelles</h2>
		  <div class="p-field p-ai-start">
			<label for="username">Nom d'utilisateur</label>
			<skeleton-loader-vue v-if="!isLoaded"
				type="rect"
				:width="450"
				:height="40"
				animation="wave"
				rounded
			/>
			<InputText
			  v-if="isLoaded"
			  id="username"
			  required
			  type="text"
			  v-model="user.username"
			  placeholder="VotreIdentifiantRigolo"
			/>
		  </div>

      <div class="errors" v-if="errors.username.length">
        <Message severity="warn">
          <ul>
            <li v-for="(error, key) in errors.username" :key="key">{{ error }}</li>
          </ul>
        </Message>
      </div>

		  <div class="p-field p-ai-start">
			<label for="email">Adresse mail</label>
			<skeleton-loader-vue v-if="!isLoaded"
				type="rect"
				:width="450"
				:height="40"
				animation="wave"
				rounded
			/>
			<InputText
			  v-if="isLoaded"
			  id="email"
			  required
			  type="email"
			  v-model="user.email"
			  placeholder="adresse@mail.com"
			/>
		  </div>

      <div class="errors" v-if="errors.email.length">
        <Message severity="warn">
          <ul>
            <li v-for="(error, key) in errors.email" :key="key">{{ error }}</li>
          </ul>
        </Message>
      </div>

		  <div class="flex p-jc-end" v-if="isLoaded">
			  <Button
				type="submit"
				class="bg-validate btn-green"
				icon="mdi-content-save"
				:icon-size="20"
				label="Enregistrer"
        :disabled="
          user.username === currentUsername &&
          user.email === currentEmail &&
          user.color === currentColor
        "
				/>
		  </div>
		</div>
		<div class="flex flex-col p-ai-start w-1/3 my-5 px-5 pt-5">
		  <div
			id="avatar"
			class="flex p-jc-center p-ai-center h-100"
			v-bind:style="{ 'background-color': user.color }"
		  >
			<img :src="avatar_face" alt=":)" width="100" />
		  </div>
		  <div id="avatar-color" class="flex p-field mt-5">
			<skeleton-loader-vue v-if="!isLoaded"
				type="rect"
				:width="200"
				:height="40"
				animation="wave"
				rounded
			/>
			<v-swatches
			  v-model="user.color"
			  row-length="5"
			  :swatches="swatches"
			  popover-x="left"
			  popover-y="bottom"
			  class="relative"
			  v-if="isLoaded"
			>
			  <InputText
				id="color"
				:value="user.color"
				slot="trigger"
				class="p-field p-simple-padding mb-0"
				readonly
			  />
			</v-swatches>
			<Button
				class="mx-2 button-input"
				icon="mdi-palette"
				:icon-size="20"
				v-if="isLoaded"
     		 />

        <div class="errors" v-if="errors.color.length">
          <Message severity="warn">
            <ul>
              <li v-for="(error, key) in errors.color" :key="key">{{ error }}</li>
            </ul>
          </Message>
        </div>
		  </div>
		</div>
	  </form>

    <!-- ANCHOR Mot de passe -->
	  <form id="user-password" method="post" class="flex" @submit.prevent="updatePassword">
      <div class="flex flex-col w-2/5 my-5 input-col mr-5">
        <h2>Changer de mot de passe</h2>
        <div class="p-field p-ai-start">
          <label for="password">Mot de passe actuel</label>
          <skeleton-loader-vue v-if="!isLoaded"
            type="rect"
            :width="450"
            :height="40"
            animation="wave"
            rounded
          />
          <InputText
            v-if="isLoaded"
            id="password"
            required
            type="password"
            v-model="user.password"
            placeholder="Mot de passe actuel"
          />
        </div>

        <div class="errors" v-if="errors.password.length">
          <Message severity="warn">
            <ul>
              <li v-for="(error, key) in errors.password" :key="key">{{ error }}</li>
            </ul>
          </Message>
        </div>

        <div class="p-field p-ai-start">
          <label for="newPassword">Nouveau mot de passe</label>
          <skeleton-loader-vue v-if="!isLoaded"
            type="rect"
            :width="450"
            :height="40"
            animation="wave"
            rounded
          />
          <InputText
            v-if="isLoaded"
            id="newPassword"
            required
            type="password"
            v-model="user.newPassword"
            placeholder="Nouveau mot de passe"
          />
        </div>

        <div class="errors" v-if="errors.newPassword.length">
          <Message severity="warn">
            <ul>
              <li v-for="(error, key) in errors.newPassword" :key="key">{{ error }}</li>
            </ul>
          </Message>
        </div>

        <div class="flex p-jc-end" v-if="isLoaded">
          <Button
            type="submit"
            class="bg-validate btn-green"
            icon="mdi-content-save"
            :icon-size="20"
            label="Enregistrer"
            :disabled="user.password === '' || user.newPassword === ''"
          />
        </div>
      </div>
    </form>

	  <div class="flex flex-col w-2/5 my-5 input-col mr-5" id="danger-zone" v-if="isLoaded">
		<h2>Danger zone</h2>
		<p>
		  Supprimer votre compte va supprimer les projets que vous avez créés et vous retirer des
		  projets auxquels vous participez. De plus, cela rendra Snippy très triste.
		  <br />
		  Êtes-vous sûrs de vouloir faire cela ?
		</p>

		<div class="flex p-jc-end mt-2 p-relative">
		  <Button
        class="btn-red"
        @click="deleteAccount()"
        label="Supprimer mon compte"
      />
		</div>

	  </div>
	</div>
  </section>
</template>

<script>

import VueSkeletonLoader from 'skeleton-loader-vue';
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

import avatar_face from "~/assets/img/avatars/face-1.svg";
import avatar_error from "~/assets/img/avatars/face-2.svg";

import axios from 'axios';

import { mapActions } from "vuex";

export default {
  components: { VSwatches, VueSkeletonLoader },
  data: () => ({
	isLoaded: false,
	avatar_face: avatar_face,
  currentUsername: "",
  currentEmail: "",
  currentColor: "",
	user: {
	  username: "",
	  email: "",
	  color: "#ef87de",
	  password: "",
	  newPassword: "",
	},
  errors: {
    username: [],
	  email: [],
	  color: [],
	  password: [],
	  newPassword: [],
  },
	swatches: [
	  ["#DC582A", "#E8A533", "#52B367", "#49ABCC", "#6468B5"],
	  ["#FC562F", "#FFC845", "#58BF6E", "#4EB6D9", "#797EDB"],
	  ["#FA7020", "#FFE838", "#64D87E", "#56CCF2", "#868BF4"],
	  ["#FD8114", "#FFF538", "#6AE684", "#5CD6FF", "#A98BF4"],
	],
  }),
  mounted: function(){
    this.resetErrors()

	//   Récupération des données utilisateur
	axios.get('me')
    .then(response => {
      if(response.data) {
        this.user.username = this.currentUsername = response.data.username;
        this.user.email = this.currentEmail = response.data.email;
        this.user.color = this.currentColor = response.data.color;
        this.isLoaded = true;
      }
    })
    .catch(error => {
      this.$toast.add({
        severity: "error",
        summary: "Impossible de récupérer les informations de votre compte",
        detail: "Une erreur est survenue lors de la récupération des informations de votre compte, veuillez réessayer ultérieurement.",
        life: 3000,
      });
    });
  },
  methods: {
    ...mapActions({
      logoutStore: 'auth/logout',
    }),
    updateInformations() {
      this.resetErrors()

      let updatedInformations = {
        username: this.user.username,
        email: this.user.email,
        color: this.user.color,
      }

      axios.put('me', updatedInformations)
        .then(r => {
          this.avatar_face = avatar_face;
          this.$toast.add({
            severity: "success",
            summary: "Modifications enregistrées !",
            life: 3000,
          });
          this.$store.dispatch('auth/updateUsername', this.user.username)
        })
        .catch(e => {
          this.errors.username = e.response.data.errors.username || []
          this.errors.email = e.response.data.errors.email || []
          this.errors.color = e.response.data.errors.color || []

          this.avatar_face = avatar_error;
        })
    },
    updatePassword() {
      this.resetErrors()

      let updatedPassword = {
        password: this.user.password,
        newPassword: this.user.newPassword,
      }

      axios.put('me/password', updatedPassword)
        .then(r => {
          this.avatar_face = avatar_face;
          this.$toast.add({
            severity: "success",
            summary: "Mot de passe modifié avec succès",
            life: 3000,
          });
        })
        .catch(e => {
          this.errors.password = e.response.data.errors.password || []
          this.errors.newPassword = e.response.data.errors.newPassword || []

          this.avatar_face = avatar_error;
        })
    },
	deleteAccount() {
		this.$confirm.require({
			header: 'Suppression de compte',
			icon: 'pi pi-exclamation-triangle',
			message: 'Êtes-vous sûr de vouloir supprimer votre compte ?',
      		acceptClass: 'p-button-danger',
			acceptLabel: 'Adieu, Snippy !',
			rejectLabel: 'Non',
			defaultFocus: "reject",
			accept: () => {
				axios.delete('me')
          .then(response => {
            this.logoutStore().then(() => {
              this.$router.push({ name: 'Accueil' });
            });
          })
          .catch(error => {
            this.$toast.add({
              severity: "error",
              summary: "Impossible de supprimer votre compte",
              detail: "Une erreur est survenue lors de la suppression de votre compte, veuillez réessayer ultérieurement.",
              life: 3000,
            });
          });
			},
			reject: () => {
				return false;
			}
		});
	},
  resetErrors() {
    this.errors = {
      username: [],
      email: [],
      color: [],
      password: [],
      newPassword: [],
    }
  },
  },
};
</script>
